<template>
  <div class="liftEdit">
    <form>
      <div class="form-group">
        <h4 class="m-0 mt-3">
          Start Location
        </h4>
        <hr class="m-0 mb-3" />
        <div class="ml-3">
          <template v-if="missingStartLocation">
            <div class="form-check form-check-inline mb-3 mt-2">
              <input
                id="useExistingStart"
                v-model="useExistingStart"
                class="form-check-input"
                type="checkbox"
              />
              <label
                class="form-check-label"
                for="useExistingStart"
              >Use Existing</label>
            </div>
            <div class="m-0 mb-1" />
            <template v-if="!useExistingStart">
              <!-- <label>{{ $t("type") }}</label>
              <select
                v-model="startLocation.type"
                :class="[
                  'form-control',
                  { 'is-invalid': $validator.errors.has('Type') },
                ]"
              >
                <option
                  v-for="(sType, index) in cPointTypes"
                  :key="`spotType-spot-${index}`"
                  :value="sType"
                >
                  {{ `${sType}` }}
                </option>
              </select> -->
            </template>
            <template v-else>
              <label>{{ $t("Location") }}</label>
              <select
                v-model="startLocation"
                :class="[
                  'form-control',
                  { 'is-invalid': $validator.errors.has('Type') },
                ]"
              >
                <optgroup
                  v-for="group in locationGroups"
                  :key="`loc-group-${group.resortId}`"
                  :label="group.label"
                >
                  <option
                    v-for="loc in group.locations"
                    :key="`loc-start-${loc.id}`"
                    :value="loc"
                  >
                    {{ `Location ${loc.id}` }}
                  </option>
                </optgroup>
              </select>
            </template>
          </template>
          <template v-else>
            <label>Location</label>
            <select
              v-model="startLocation"
              :class="[
                'form-control',
                { 'is-invalid': $validator.errors.has('Type') },
              ]"
            >
              <optgroup
                v-for="group in locationGroups"
                :key="`loc-group-start-existing-${group.resortId}`"
                :label="group.label"
              >
                <option
                  v-for="loc in group.locations"
                  :key="`loc-start-existing-${group.resortId}-${loc.id}`"
                  :value="loc"
                >
                  {{ `Location ${loc.id}` }}
                </option>
              </optgroup>
            </select>
            <hr class="m-0 mb-3" />
          </template>
          <label>{{ $t("altitude") }}</label>
          <input
            v-model="startLocation.location.altitude"
            :class="[
              'form-control',
              { 'is-invalid': $validator.errors.has('Altitude') },
            ]"
            type="text"
          />
          <hr class="m-0 mb-3" />
          <label>{{ $t("latitude") }}</label>
          <input
            v-model="startLocation.location.latitude"
            :class="[
              'form-control',
              { 'is-invalid': $validator.errors.has('Altitude') },
            ]"
            type="text"
          />
          <hr class="m-0 mb-3" />
          <label>{{ $t("longitude") }}</label>
          <input
            v-model="startLocation.location.longitude"
            :class="[
              'form-control',
              { 'is-invalid': $validator.errors.has('Altitude') },
            ]"
            type="text"
          />
          <hr class="m-0 mb-3" />
          <template v-if="missingStartLocation">
            <div class="form-check form-check-inline mb-3 mt-2">
              <input
                id="cStartPoint"
                v-model="createStartPoint"
                class="form-check-input"
                type="checkbox"
              />
              <label
                class="form-check-label"
                for="cStartPoint"
              >{{ useExistingStart ? "Upsert" : "Add" }} Start Point</label>
            </div>
            <LoadingPlaceholder v-if="pointLoading && createStartPoint" />
            <div v-else-if="createStartPoint && startPoint">
              <h5>Start Point</h5>
              <!-- <hr class="m-0 mb-3" />
              <div class="form-check form-check-inline mb-3 mt-2">
                <input
                  id="cUseExistingStart"
                  v-model="useExistingStartPoint"
                  class="form-check-input"
                  type="checkbox"
                />
                <label
                  class="form-check-label"
                  for="cUseExistingStart"
                >Use Existing Start Point</label>
              </div> -->
              <hr class="m-0 mb-3" />
              <template v-if="useExistingStartPoint">
                <label>{{ $t("Point") }}</label>
                <select
                  v-model="selectedStartPointId"
                  :class="[
                    'form-control',
                    { 'is-invalid': $validator.errors.has('Type') },
                  ]"
                >
                  <option
                    v-for="(rp, index) in resortPoints"
                    :key="`spotTyp1e-spot-${index}`"
                    :value="rp.id"
                  >
                    {{ `${rp.id} - ${rp.name}` }}
                  </option>
                </select>
                <hr class="m-0 mb-3" />
              </template>
              <label>{{ $t("key") }}</label>
              <input
                v-model="startPoint.key"
                :class="[
                  'form-control',
                  { 'is-invalid': $validator.errors.has('Key') },
                ]"
                type="text"
              />
              <hr class="m-0 mb-3" />
              <label>{{ $t("name") }}</label>
              <input
                v-model="startPoint.name"
                :class="[
                  'form-control',
                  { 'is-invalid': $validator.errors.has('Name') },
                ]"
                type="text"
              />
              <hr class="m-0 mb-3" />
              <label>Spot type</label>
              <select
                v-model="startPoint.typeId"
                :class="[
                  'form-control',
                  { 'is-invalid': $validator.errors.has('Type') },
                ]"
              >
                <option
                  v-for="(pointType, index) in pointTypes"
                  :key="`pointType-spot1-${index}`"
                  :value="pointType.id"
                >
                  {{ `${pointType.id} - ${pointType.name}` }}
                </option>
              </select>
              <hr class="m-0 mb-3" />
              <label>External ID</label>
              <input
                v-model="startExternalIdsString"
                :class="[
                  'form-control',
                  { 'is-invalid': $validator.errors.has('st') },
                ]"
                type="text"
              />
              <small
                class="form-text text-muted"
              >You can enter multiple IDs separated by commas.</small>
              <hr class="m-0 mb-3" />
              <div class="form-check form-check-inline mb-3 mt-2">
                <input
                  id="active"
                  v-model="startPoint.active"
                  class="form-check-input"
                  type="checkbox"
                />
                <label
                  class="form-check-label"
                  for="active"
                >Active</label>
              </div>
              <div class="form-check form-check-inline mb-3 mt-2">
                <input
                  id="visible"
                  v-model="startPoint.visible"
                  class="form-check-input"
                  type="checkbox"
                />
                <label
                  class="form-check-label"
                  for="visible"
                >Visible</label>
              </div>
            </div>
          </template>
          <template v-else>
            <LoadingPlaceholder v-if="pointLoading" />
            <div v-else-if="startPoint">
              <h5>Start Point</h5>
              <hr class="m-0 mb-3" />
              <label>{{ $t("key") }}</label>
              <input
                v-model="startPoint.key"
                :class="[
                  'form-control',
                  { 'is-invalid': $validator.errors.has('Key') },
                ]"
                type="text"
              />
              <hr class="m-0 mb-3" />
              <label>{{ $t("name") }}</label>
              <input
                v-model="startPoint.name"
                :class="[
                  'form-control',
                  { 'is-invalid': $validator.errors.has('Name') },
                ]"
                type="text"
              />
              <hr class="m-0 mb-3" />
              <label>Spot type</label>
              <select
                v-model="startPoint.typeId"
                :class="[
                  'form-control',
                  { 'is-invalid': $validator.errors.has('Type') },
                ]"
              >
                <option
                  v-for="(pointType, index) in pointTypes"
                  :key="`pointType-spot1-${index}`"
                  :value="pointType.id"
                >
                  {{ `${pointType.id} - ${pointType.name}` }}
                </option>
              </select>
              <hr class="m-0 mb-3" />
              <label>External ID</label>
              <input
                v-model="startExternalIdsString"
                :class="[
                  'form-control',
                  { 'is-invalid': $validator.errors.has('st') },
                ]"
                type="text"
              />
              <small
                class="form-text text-muted"
              >You can enter multiple IDs separated by commas.</small>
              <hr class="m-0 mb-3" />
              <div class="form-check form-check-inline mb-3 mt-2">
                <input
                  id="active"
                  v-model="startPoint.active"
                  class="form-check-input"
                  type="checkbox"
                />
                <label
                  class="form-check-label"
                  for="active"
                >Active</label>
              </div>
              <div class="form-check form-check-inline mb-3 mt-2">
                <input
                  id="visible"
                  v-model="startPoint.visible"
                  class="form-check-input"
                  type="checkbox"
                />
                <label
                  class="form-check-label"
                  for="visible"
                >Visible</label>
              </div>
            </div>
          </template>
        </div>
        <h4 class="m-0 mt-3">
          End Location
        </h4>
        <hr class="m-0 mb-3" />
        <div class="ml-3">
          <template v-if="missingEndLocation">
            <div class="form-check form-check-inline mb-3 mt-2">
              <input
                id="useExistingEnd"
                v-model="useExistingEnd"
                class="form-check-input"
                type="checkbox"
              />
              <label
                class="form-check-label"
                for="useExistingEnd"
              >Use Existing</label>
            </div>
            <div class="m-0 mb-1" />
            <template v-if="!useExistingEnd">
              <!-- <label>{{ $t("type") }}</label>
              <select
                v-model="endLocation.type"
                :class="[
                  'form-control',
                  { 'is-invalid': $validator.errors.has('Type') },
                ]"
              >
                <option
                  v-for="(sType, index) in cPointTypes"
                  :key="`spotType-spot-${index}`"
                  :value="sType"
                >
                  {{ `${sType}` }}
                </option>
              </select> -->
            </template>
            <template v-else>
              <label>{{ $t("Location") }}</label>
              <select
                v-model="endLocation"
                :class="[
                  'form-control',
                  { 'is-invalid': $validator.errors.has('Type') },
                ]"
              >
                <optgroup
                  v-for="group in locationGroups"
                  :key="`loc-group-${group.resortId}`"
                  :label="group.label"
                >
                  <option
                    v-for="loc in group.locations"
                    :key="`loc-end-${loc.id}`"
                    :value="loc"
                  >
                    {{ `Location ${loc.id}` }}
                  </option>
                </optgroup>
              </select>
            </template>
          </template>
          <template v-else>
            <label>Location</label>
            <select
              v-model="endLocation"
              :class="[
                'form-control',
                { 'is-invalid': $validator.errors.has('Type') },
              ]"
            >
              <optgroup
                v-for="group in locationGroups"
                :key="`loc-group-end-existing-${group.resortId}`"
                :label="group.label"
              >
                <option
                  v-for="loc in group.locations"
                  :key="`loc-end-existing-${group.resortId}-${loc.id}`"
                  :value="loc"
                >
                  {{ `Location ${loc.id}` }}
                </option>
              </optgroup>
            </select>
            <hr class="m-0 mb-3" />
          </template>
          <label>{{ $t("altitude") }}</label>
          <input
            v-model="endLocation.location.altitude"
            :class="[
              'form-control',
              { 'is-invalid': $validator.errors.has('Altitude') },
            ]"
            type="text"
          />
          <hr class="m-0 mb-3" />
          <label>{{ $t("latitude") }}</label>
          <input
            v-model="endLocation.location.latitude"
            :class="[
              'form-control',
              { 'is-invalid': $validator.errors.has('Altitude') },
            ]"
            type="text"
          />
          <hr class="m-0 mb-3" />
          <label>{{ $t("longitude") }}</label>
          <input
            v-model="endLocation.location.longitude"
            :class="[
              'form-control',
              { 'is-invalid': $validator.errors.has('Altitude') },
            ]"
            type="text"
          />
          <hr class="m-0 mb-3" />
          <template v-if="missingEndLocation">
            <div class="form-check form-check-inline mb-3 mt-2">
              <input
                id="cEndPoint"
                v-model="createEndPoint"
                class="form-check-input"
                type="checkbox"
              />
              <label
                class="form-check-label"
                for="cEndPoint"
              >{{ useExistingEnd ? "Upsert" : "Add" }} End Point</label>
            </div>
            <LoadingPlaceholder v-if="pointLoading && createEndPoint" />
            <div v-else-if="createEndPoint && endPoint">
              <h5>End Point</h5>
              <!-- <hr class="m-0 mb-3" />
              <div class="form-check form-check-inline mb-3 mt-2">
                <input
                  id="cUseExistingEnd"
                  v-model="useExistingEndPoint"
                  class="form-check-input"
                  type="checkbox"
                />
                <label
                  class="form-check-label"
                  for="cUseExistingEnd"
                >Use Existing End Point</label>
              </div> -->
              <hr class="m-0 mb-3" />
              <template v-if="useExistingEndPoint">
                <label>{{ $t("Point") }}</label>
                <select
                  v-model="selectedEndPointId"
                  :class="[
                    'form-control',
                    { 'is-invalid': $validator.errors.has('Type') },
                  ]"
                >
                  <option
                    v-for="(rp, index) in resortPoints"
                    :key="`spotTyp2e-spot-${index}`"
                    :value="rp.id"
                  >
                    {{ `${rp.id} - ${rp.name}` }}
                  </option>
                </select>
                <hr class="m-0 mb-3" />
              </template>
              <label>{{ $t("key") }}</label>
              <input
                v-model="endPoint.key"
                :class="[
                  'form-control',
                  { 'is-invalid': $validator.errors.has('Key') },
                ]"
                type="text"
              />
              <hr class="m-0 mb-3" />
              <label>{{ $t("name") }}</label>
              <input
                v-model="endPoint.name"
                :class="[
                  'form-control',
                  { 'is-invalid': $validator.errors.has('Name') },
                ]"
                type="text"
              />
              <hr class="m-0 mb-3" />
              <label>Spot type</label>
              <select
                v-model="endPoint.typeId"
                :class="[
                  'form-control',
                  { 'is-invalid': $validator.errors.has('Type') },
                ]"
              >
                <option
                  v-for="(pointType, index) in pointTypes"
                  :key="`pointType-spot-${index}`"
                  :value="pointType.id"
                >
                  {{ `${pointType.id} - ${pointType.name}` }}
                </option>
              </select>
              <hr class="m-0 mb-3" />
              <label>External ID</label>
              <input
                v-model="endExternalIdsString"
                :class="[
                  'form-control',
                  { 'is-invalid': $validator.errors.has('st') },
                ]"
                type="text"
              />
              <small
                class="form-text text-muted"
              >You can enter multiple IDs separated by commas.</small>
              <hr class="m-0 mb-3" />
              <div class="form-check form-check-inline mb-3 mt-2">
                <input
                  id="endActive"
                  v-model="endPoint.active"
                  class="form-check-input"
                  type="checkbox"
                />
                <label
                  class="form-check-label"
                  for="endActive"
                >Active</label>
              </div>
              <div class="form-check form-check-inline mb-3 mt-2">
                <input
                  id="endVisible"
                  v-model="endPoint.visible"
                  class="form-check-input"
                  type="checkbox"
                />
                <label
                  class="form-check-label"
                  for="endVisible"
                >Visible</label>
              </div>
            </div>
          </template>
          <template v-else>
            <LoadingPlaceholder v-if="pointLoading" />
            <div v-else-if="endPoint">
              <h5>End Point</h5>
              <hr class="m-0 mb-3" />
              <label>{{ $t("key") }}</label>
              <input
                v-model="endPoint.key"
                :class="[
                  'form-control',
                  { 'is-invalid': $validator.errors.has('Key') },
                ]"
                type="text"
              />
              <hr class="m-0 mb-3" />
              <label>{{ $t("name") }}</label>
              <input
                v-model="endPoint.name"
                :class="[
                  'form-control',
                  { 'is-invalid': $validator.errors.has('Name') },
                ]"
                type="text"
              />
              <hr class="m-0 mb-3" />
              <label>Spot type</label>
              <select
                v-model="endPoint.typeId"
                :class="[
                  'form-control',
                  { 'is-invalid': $validator.errors.has('Type') },
                ]"
              >
                <option
                  v-for="(pointType, index) in pointTypes"
                  :key="`pointType-spot-${index}`"
                  :value="pointType.id"
                >
                  {{ `${pointType.id} - ${pointType.name}` }}
                </option>
              </select>
              <hr class="m-0 mb-3" />
              <label>External ID</label>
              <input
                v-model="endExternalIdsString"
                :class="[
                  'form-control',
                  { 'is-invalid': $validator.errors.has('st') },
                ]"
                type="text"
              />
              <small
                class="form-text text-muted"
              >You can enter multiple IDs separated by commas.</small>
              <hr class="m-0 mb-3" />
              <div class="form-check form-check-inline mb-3 mt-2">
                <input
                  id="endActive"
                  v-model="endPoint.active"
                  class="form-check-input"
                  type="checkbox"
                />
                <label
                  class="form-check-label"
                  for="endActive"
                >Active</label>
              </div>
              <div class="form-check form-check-inline mb-3 mt-2">
                <input
                  id="endVisible"
                  v-model="endPoint.visible"
                  class="form-check-input"
                  type="checkbox"
                />
                <label
                  class="form-check-label"
                  for="endVisible"
                >Visible</label>
              </div>
            </div>
          </template>
        </div>
        <h4 class="m-0 mt-3">
          {{ "Section" }}
        </h4>
        <hr class="m-0 mb-3" />
        <div class="ml-3">
          <label>{{ $t("name") }}</label>
          <input
            v-model="section.name"
            :class="[
              'form-control',
              { 'is-invalid': $validator.errors.has('Name') },
            ]"
            type="text"
          />
          <hr class="m-0 mb-3" />
          <label>{{ $t("type") }}</label>
          <select
            v-model="section.typeId"
            :class="[
              'form-control',
              { 'is-invalid': $validator.errors.has('Type') },
            ]"
          >
            <option
              v-for="(type, index) in sectionTypes"
              :key="`spotType-spot-${index}`"
              :value="type.id"
            >
              {{ `${type.id} - ${type.name}` }}
            </option>
          </select>
          <hr class="m-0 mb-3" />
          <label>{{ $t("length") }}</label>
          <input
            v-model="section.length"
            :class="[
              'form-control',
              { 'is-invalid': $validator.errors.has('Length') },
            ]"
            type="text"
          />
          <label>{{ $t("resortForm.multipleValue") }}</label>
          <hr class="m-0 mb-3" />
          <label>{{ $t("duration") }}</label>
          <input
            v-model="section.duration"
            :class="[
              'form-control',
              { 'is-invalid': $validator.errors.has('Duration') },
            ]"
            type="text"
          />
          <hr class="m-0 mb-3" />
          <div class="form-check form-check-inline mb-3 mt-2">
            <input
              id="active"
              v-model="section.active"
              class="form-check-input"
              type="checkbox"
            />
            <label
              class="form-check-label"
              for="active"
            >Active</label>
          </div>
          <hr class="m-0 mb-3" />
          <div class="form-check form-check-inline mb-3 mt-2">
            <input
              id="manuallyAddable"
              v-model="section.manuallyAddable"
              class="form-check-input"
              type="checkbox"
            />
            <label
              class="form-check-label"
              for="manuallyAddable"
            >Manually Addable</label>
          </div>
        </div>
      </div>
      <LoadingPlaceholder v-if="upsertLoading" />
      <button
        v-else
        class="btn btn-primary float-right"
        @click.prevent="editLift()"
      >
        <font-awesome-icon
          class="mr-2"
          icon="edit"
        />{{ $t("edit") }}
      </button>
      <div class="clearfix" />
    </form>
  </div>
</template>

<script>
import { errorMixin } from "@/mixins/errorMixin.js";

export default {
  name: "LiftEdit",
  mixins: [errorMixin],
  props: {
    section: {
      type: Object,
      required: true,
    },
    locations: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      sectionTypes: null,
      startLocation: null,
      endLocation: null,
      missingStartLocation: false,
      missingEndLocation: false,
      useExistingStart: false,
      useExistingEnd: false,
      createStartPoint: false,
      useExistingStartPoint: false,
      createEndPoint: false,
      useExistingEndPoint: false,
      selectedStartPointId: null,
      selectedEndPointId: null,
      upsertLoading: false,
      pointLoading: false,
      startPoint: null,
      endPoint: null,
      resortPoints: [],
      pointTypes: [],
    };
  },
  computed: {
    locationGroups() {
      const groups = {};
      (this.locations || []).forEach((loc) => {
        const resortId = loc.resortId || this.resortId;
        if (!groups[resortId]) {
          groups[resortId] = [];
        }
        groups[resortId].push(loc);
      });
      return Object.keys(groups)
        .map((id) => ({
          resortId: Number(id),
          label: `Resort ${id}`,
          locations: groups[id],
        }))
        .sort((a, b) => a.resortId - b.resortId);
    },
    startExternalIdsString: {
      get() {
        if (this.startPoint && this.startPoint.externalIds) {
          return this.startPoint.externalIds.join(",");
        }
        return "";
      },
      set(val) {
        if (!this.startPoint) {
          this.startPoint = { id: -1, externalIds: [] };
        }
        this.startPoint.externalIds = val.split(",").map((x) => x.trim());
      },
    },
    endExternalIdsString: {
      get() {
        if (this.endPoint && this.endPoint.externalIds) {
          return this.endPoint.externalIds.join(",");
        }
        return "";
      },
      set(val) {
        if (!this.endPoint) {
          this.endPoint = { id: -1, externalIds: [] };
        }
        this.endPoint.externalIds = val.split(",").map((x) => x.trim());
      },
    },
  },
  watch: {
    createStartPoint() {
      if (!this.missingStartLocation) {
        return;
      }
      if (this.createStartPoint) {
        const match = this.resortPoints.find(
          (rp) =>
            rp.locationId === Number(this.startLocation ? this.startLocation.id : -100)
        );
        this.startPoint = match
          ? this.clone(match)
          : {
              id: -1,
              externalIds: [],
            };
      } else {
        this.startPoint = null;
      }
    },
    createEndPoint() {
      if (!this.missingEndLocation) {
        return;
      }
      if (this.createEndPoint) {
        const match = this.resortPoints.find(
          (rp) =>
            rp.locationId === Number(this.endLocation ? this.endLocation.id : -100)
        );
        this.endPoint = match
          ? this.clone(match)
          : {
              id: -1,
              externalIds: [],
            };
      } else {
        this.endPoint = null;
      }
    },
    useExistingStartPoint() {
      if (!this.missingStartLocation) {
        return;
      }
      if (!this.useExistingStartPoint) {
        this.startPoint = {
          id: -1,
          externalIds: [],
        };
        this.selectedStartPointId = null;
      } else {
        this.startPoint = {
          externalIds: [],
        };
        this.selectedStartPointId = null;
      }
    },
    useExistingEndPoint() {
      if (!this.missingEndLocation) {
        return;
      }
      if (!this.useExistingEndPoint) {
        this.endPoint = {
          id: -1,
          externalIds: [],
        };
        this.selectedEndPointId = null;
      } else {
        this.endPoint = {
          externalIds: [],
        };
        this.selectedEndPointId = null;
      }
    },
    selectedStartPointId(val) {
      if (!this.useExistingStartPoint) {
        return;
      }
      const match = this.resortPoints.find((rp) => rp.locationId === Number(val));
      this.startPoint = match
        ? this.clone(match)
        : {
            id: -1,
            externalIds: [],
          };
    },
    selectedEndPointId(val) {
      if (!this.useExistingEndPoint) {
        return;
      }
      const match = this.resortPoints.find((rp) => rp.locationId === Number(val));
      this.endPoint = match
        ? this.clone(match)
        : {
            id: -1,
            externalIds: [],
          };
    },
    useExistingStart() {
      if (!this.missingStartLocation) {
        return;
      }
      if (this.useExistingStart && this.locations.length > 0) {
        this.startLocation = this.locations[0];
        if (this.createStartPoint) {
          const match = this.resortPoints.find(
            (rp) => rp.locationId === Number(this.startLocation.id)
          );
          this.startPoint = match
            ? this.clone(match)
            : {
                id: -1,
                externalIds: [],
              };
        }
      } else {
        this.startLocation = {
          id: -1,
          location: {
            altitude: null,
            latitude: null,
            longitude: null,
          },
        };
        if (this.createStartPoint) {
          this.startPoint = {
            id: -1,
            externalIds: [],
          };
        }
      }
    },
    useExistingEnd() {
      if (!this.missingEndLocation) {
        return;
      }
      if (this.useExistingEnd && this.locations.length > 0) {
        this.endLocation = this.locations[0];
        if (this.createEndPoint) {
          const match = this.resortPoints.find(
            (rp) => rp.locationId === Number(this.endLocation.id)
          );
          this.endPoint = match
            ? this.clone(match)
            : {
                id: -1,
                externalIds: [],
              };
        }
      } else {
        this.endLocation = {
          id: -1,
          location: {
            altitude: null,
            latitude: null,
            longitude: null,
          },
        };
        if (this.createEndPoint) {
          this.endPoint = {
            id: -1,
            externalIds: [],
          };
        }
      }
    },
    'startLocation.id'() {
      if (!this.startLocation || !this.startLocation.id) {
        return;
      }

      if (this.missingStartLocation && this.createStartPoint) {
        const match = this.resortPoints.find(
          (rp) =>
            rp.locationId === Number(this.startLocation ? this.startLocation.id : -100)
        );
        this.startPoint = match
          ? this.clone(match)
          : {
              id: -1,
              externalIds: [],
            };
        return;
      }

      const match = this.resortPoints.find(
        (rp) =>
          rp.locationId === Number(this.startLocation ? this.startLocation.id : -100)
      );
      this.startPoint = match ? this.clone(match) : null;
    },
    'endLocation.id'() {
      if (!this.endLocation || !this.endLocation.id) {
        return;
      }

      if (this.missingEndLocation && this.createEndPoint) {
        const match = this.resortPoints.find(
          (rp) =>
            rp.locationId === Number(this.endLocation ? this.endLocation.id : -100)
        );
        this.endPoint = match
          ? this.clone(match)
          : {
              id: -1,
              externalIds: [],
            };
        return;
      }

      const match = this.resortPoints.find(
        (rp) => rp.locationId === Number(this.endLocation ? this.endLocation.id : -100)
      );
      this.endPoint = match ? this.clone(match) : null;
    },
  },
  created() {
    this.startLocation = this.locations.find(
      (x) => x.id === this.section.startLocationId
    );
    this.missingStartLocation = !this.startLocation;
    if (this.missingStartLocation) {
      this.startLocation = {
        id: -1,
        location: {
          altitude: null,
          latitude: null,
          longitude: null,
        },
      };
      this.useExistingStart = false;
    }
    this.endLocation = this.locations.find(
      (x) => x.id === this.section.endLocationId
    );
    this.missingEndLocation = !this.endLocation;
    if (this.missingEndLocation) {
      this.endLocation = {
        id: -1,
        location: {
          altitude: null,
          latitude: null,
          longitude: null,
        },
      };
      this.useExistingEnd = false;
    }
    this.getPointTypes();
    this.getResortLifts();
    this.getSectionTypes();
  },
  methods: {
    clone(item) {
      return JSON.parse(JSON.stringify(item));
    },
    getSectionTypes() {
      this.axios
        .get(`/Resort/GetResortSectionTypes`)
        .then((response) => {
          this.sectionTypes = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getResortLifts() {
      this.pointLoading = true;
      this.axios
        .get(`/Resort/GetResortLiftPoint?resortId=${this.section.resortId}&includeSharedResorts=true`)
        .then((response) => {
          this.resortPoints = response.data;
          const startLocationId = this.startLocation ? Number(this.startLocation.id) : Number(this.section.startLocationId);
          const endLocationId = this.endLocation ? Number(this.endLocation.id) : Number(this.section.endLocationId);
          const startMatch = this.resortPoints.find(
            (x) => Number(x.locationId) === startLocationId
          );
          const endMatch = this.resortPoints.find(
            (x) => Number(x.locationId) === endLocationId
          );
          this.startPoint = startMatch || null;
          this.endPoint = endMatch || null;
        })
        .finally(() => {
          this.pointLoading = false;
        });
    },
    async editLift() {
      this.upsertLoading = true;
      this.cleanExternalIds(this.startPoint);
      this.cleanExternalIds(this.endPoint);
      const startPoint = this.missingStartLocation
        ? (this.createStartPoint ? this.startPoint : null)
        : this.startPoint;
      const endPoint = this.missingEndLocation
        ? (this.createEndPoint ? this.endPoint : null)
        : this.endPoint;
      var lift = {
        section: this.section,
        startLocation: this.startLocation,
        endLocation: this.endLocation,
        startPoint: startPoint,
        endPoint: endPoint,
      };
      await this.axios
        .post("/Resort/EditLift", lift)
        .then(() => {
          this.$snotify.success(this.$t("resortForm.updatedSuccessfullyLift"));
          this.$emit("reload");
          this.error_clear();
          this.upsertLoading = false;
        })
        .catch((error) => {
          this.error_clear();
          this.error_validate(error);
        });
    },
    getPointTypes() {
      this.loading = true;
      this.axios
        .get(`/Resort/GetPointTypes`)
        .then((response) => {
          this.pointTypes = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    cleanExternalIds(point) {
      if (!point || !point.externalIds) {
        return;
      }
      point.externalIds = point.externalIds.filter((x) => x && x.length > 0);
    },
  },
};
</script>

<style scoped>
.liftEdit.progress {
  display: flex;
  flex: 1 1 auto;
  width: 1%;
  height: 20px;
  font-size: 1rem;
}
</style>
